import * as React from "react";
import { forwardRef } from "react";
const SvgCross3 = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 13, height: 14, fill: "none", viewBox: "0 0 13 14", ref, ...props }, /* @__PURE__ */ React.createElement("path", { stroke: "currentColor", d: "M.657 12.657 6.314 7m5.657-5.657L6.314 7m5.657 5.657L6.314 7m0 0L.657 1.343" }));
const ForwardRef = forwardRef(SvgCross3);
export default ForwardRef;
